import { createSelector } from "reselect";
import { isEmpty } from "lodash";
import { isRiverrDomain } from "../utils";

const currentUserRecord = (state) => state?.currentUser?.user || {};
const currentEnterpriseRecord = (state) => state?.currentUser?.enterprise || {};
const pricingRecords = (state) => state?.pricings?.pricings || {};

export const activePlanSelector = createSelector(
  [currentUserRecord, currentEnterpriseRecord, pricingRecords],
  (currentUser, currentEnterprise, pricings) => {
    const { isEnterpriseAdmin, isProUser, planId: userPlanId } =
      currentUser || {};
    const enterprisePlanId = currentEnterprise?.planId;

    // Feature gates for a tenant follow enterprises.planId (billing source of
    // truth). users.planId is a signup-time copy that can drift after
    // upgrades, reconciles, or manual ops fixes.
    let planKey = userPlanId || "RIVERRFREE";
    if (isEnterpriseAdmin && enterprisePlanId) {
      planKey = enterprisePlanId;
    } else if (isEnterpriseAdmin && !isProUser) {
      planKey = "RIVERRPRO99";
    }

    if (!isRiverrDomain) {
      planKey = "RIVERRPRO99";
    }

    let activePlan = pricings?.[planKey];

    if (!isEmpty(activePlan)) {
      let keyedFeatures = {};
      (activePlan?.features || []).forEach(({ id, active }) => {
        keyedFeatures = {
          ...keyedFeatures,
          [id]: active,
        };
      });
      // Canonical plans (growth+) renamed the feature; legacy route guards
      // still check PRINTERNETWORKINTEGRATION.
      if (keyedFeatures["Manufacturing Support"]) {
        keyedFeatures.PRINTERNETWORKINTEGRATION = true;
      }

      activePlan = {
        ...activePlan,
        keyedFeatures,
      };
    }

    return activePlan;
  }
);

export const keyedFeaturesSelector = createSelector(
  [activePlanSelector],
  (activePlan) => {
    return activePlan?.keyedFeatures || {};
  }
);

export const activeEnterprisePlanSelector = createSelector(
  [currentEnterpriseRecord, pricingRecords],
  (currentEnterprise, pricings) => {
    const { planId } = currentEnterprise || {};

    let activePlan = pricings?.[planId];

    return activePlan;
  }
);
